export default __webpack_public_path__ + "static/media/icomoon.c56dc73a.eot";